import { AirlineModel } from 'api-hooks/airline';
import { Expose, Type } from 'class-transformer';
import { CommonModel } from 'common/repositories/common.model';

export class PreferenceModel extends CommonModel {
  name: string;
}

// export class AirlineModel {
//   address: string;
//   code: string;
//   email: string;
//   id: string;
//   name: string;
//   phone: string;

//   @Expose({ name: 'phone_2' })
//   phone2: string;
// }

export class TourFlightAirlinesModel {
  id: string;
  // airlineId: string | null;
  detail: string;
  route: string;
  time: string;

  @Type(() => Date)
  date?: Date;

  @Type(() => Number)
  price: number;
  // preferenceId: string;

  @Type(() => PreferenceModel)
  preference: PreferenceModel | null;

  @Type(() => AirlineModel)
  airline: AirlineModel;
}

export class FlightModel {
  id: string;
  name: string;
  note?: string;

  @Expose({ name: 'tour_flight_airlines' })
  @Type(() => TourFlightAirlinesModel)
  tourFlightAirlines: TourFlightAirlinesModel[];

  @Expose({ name: 'ref_id' })
  refId: string;
}

export class AirlineMutationinput {
  airlineId: string | null;
  date: Date;
  detail: string;
  route: string;
  time: string;
  price: number;
  preferenceId: string;
}

export type TourFlightAirlineItemInput = {
  id?: string;
  code?: string;
  address?: string;
  email?: string;
  name?: string;
  phone?: string;
  phone2?: string;
};

export class FlightMutationInput {
  name: string;
  description?: string;

  tourFlights: TourFlightAirlineItemInput[];
}

export class FlightUpdateInput {
  tourId: string;
  body: FlightMutationInput;
}

export class getFlightTourInput {
  id: string;
}
